/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum ILabelType {
  CallToAction = 'call-to-action',
  SubCategory = 'sub-category',
  Category = 'category',
  AltDetail = 'alt-detail',
  Description = 'description',
  TitleCallout = 'title-callout',
  CompletedMessage = 'completed-message',
}
